export const schema = {
    models: {
        PlaidAccount: {
            name: 'PlaidAccount',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                userProfileId: {
                    name: 'userProfileId',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                itemId: {
                    name: 'itemId',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                balanceAvailable: {
                    name: 'balanceAvailable',
                    isArray: false,
                    type: 'Float',
                    isRequired: false,
                    attributes: [],
                },
                balanceCurrent: {
                    name: 'balanceCurrent',
                    isArray: false,
                    type: 'Float',
                    isRequired: true,
                    attributes: [],
                },
                balanceLimit: {
                    name: 'balanceLimit',
                    isArray: false,
                    type: 'Float',
                    isRequired: false,
                    attributes: [],
                },
                isoCurrencyCode: {
                    name: 'isoCurrencyCode',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                mask: {
                    name: 'mask',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                name: {
                    name: 'name',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                officialName: {
                    name: 'officialName',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                type: {
                    name: 'type',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                subtype: {
                    name: 'subtype',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
            },
            syncable: true,
            pluralName: 'PlaidAccounts',
            attributes: [
                {
                    type: 'model',
                    properties: {
                        mutations: null,
                        subscriptions: null,
                        timestamps: {
                            createdAt: 'createdOn',
                            updatedAt: 'updatedOn',
                        },
                    },
                },
                {
                    type: 'key',
                    properties: {
                        name: 'byUserProfile',
                        fields: ['userProfileId', 'balanceCurrent'],
                    },
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                provider: 'userPools',
                                ownerField: 'owner',
                                allow: 'owner',
                                identityClaim: 'cognito:username',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                        ],
                    },
                },
            ],
        },
        UserProfile: {
            name: 'UserProfile',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                email: {
                    name: 'email',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                firstName: {
                    name: 'firstName',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                lastName: {
                    name: 'lastName',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                phone: {
                    name: 'phone',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                dateOfBirth: {
                    name: 'dateOfBirth',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                },
                countryId: {
                    name: 'countryId',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                country: {
                    name: 'country',
                    isArray: false,
                    type: {
                        model: 'Country',
                    },
                    isRequired: false,
                    attributes: [],
                    association: {
                        connectionType: 'HAS_ONE',
                        associatedWith: 'id',
                        targetName: 'countryId',
                    },
                },
                loanApplicationId: {
                    name: 'loanApplicationId',
                    isArray: false,
                    type: 'ID',
                    isRequired: false,
                    attributes: [],
                },
                loanApplication: {
                    name: 'loanApplication',
                    isArray: false,
                    type: {
                        model: 'LoanApplication',
                    },
                    isRequired: false,
                    attributes: [],
                    association: {
                        connectionType: 'HAS_ONE',
                        associatedWith: 'id',
                        targetName: 'loanApplicationId',
                    },
                },
                interests: {
                    name: 'interests',
                    isArray: true,
                    type: {
                        model: 'UserProductInterest',
                    },
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                    association: {
                        connectionType: 'HAS_MANY',
                        associatedWith: 'userProfile',
                    },
                },
                lastLoginDate: {
                    name: 'lastLoginDate',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                },
                givenConsentDate: {
                    name: 'givenConsentDate',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                },
                removedConsentDate: {
                    name: 'removedConsentDate',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                },
                notifyEmail: {
                    name: 'notifyEmail',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: false,
                    attributes: [],
                },
                notifyPhone: {
                    name: 'notifyPhone',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: false,
                    attributes: [],
                },
                activeRole: {
                    name: 'activeRole',
                    isArray: false,
                    type: {
                        enum: 'UserRole',
                    },
                    isRequired: false,
                    attributes: [],
                },
                availableRoles: {
                    name: 'availableRoles',
                    isArray: true,
                    type: {
                        enum: 'UserRole',
                    },
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
                payableAddress: {
                    name: 'payableAddress',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
            },
            syncable: true,
            pluralName: 'UserProfiles',
            attributes: [
                {
                    type: 'model',
                    properties: {
                        mutations: {
                            create: 'createUserProfile',
                            update: null,
                        },
                        timestamps: {
                            createdAt: 'createdOn',
                            updatedAt: 'updatedOn',
                        },
                    },
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                provider: 'userPools',
                                ownerField: 'id',
                                allow: 'owner',
                                identityClaim: 'cognito:username',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                            {
                                allow: 'private',
                                operations: ['read'],
                            },
                        ],
                    },
                },
            ],
        },
        Country: {
            name: 'Country',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                name: {
                    name: 'name',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                abbreviation: {
                    name: 'abbreviation',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                bankApproved: {
                    name: 'bankApproved',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: true,
                    attributes: [],
                },
                pngmeApproved: {
                    name: 'pngmeApproved',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: true,
                    attributes: [],
                },
            },
            syncable: true,
            pluralName: 'Countries',
            attributes: [
                {
                    type: 'model',
                    properties: {
                        timestamps: {
                            createdAt: 'createdOn',
                            updatedAt: 'updatedOn',
                        },
                    },
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                provider: 'userPools',
                                ownerField: 'owner',
                                allow: 'owner',
                                operations: ['create', 'delete', 'update'],
                                identityClaim: 'cognito:username',
                            },
                            {
                                allow: 'private',
                                operations: ['read'],
                            },
                        ],
                    },
                },
            ],
        },
        LoanApplication: {
            name: 'LoanApplication',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                userProfileId: {
                    name: 'userProfileId',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                state: {
                    name: 'state',
                    isArray: false,
                    type: 'Int',
                    isRequired: false,
                    attributes: [],
                },
                amount: {
                    name: 'amount',
                    isArray: false,
                    type: 'Int',
                    isRequired: false,
                    attributes: [],
                },
                porpuse: {
                    name: 'porpuse',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
            },
            syncable: true,
            pluralName: 'LoanApplications',
            attributes: [
                {
                    type: 'model',
                    properties: {
                        timestamps: {
                            createdAt: 'createdOn',
                            updatedAt: 'updatedOn',
                        },
                    },
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                provider: 'userPools',
                                ownerField: 'owner',
                                allow: 'owner',
                                operations: ['create', 'delete'],
                                identityClaim: 'cognito:username',
                            },
                            {
                                allow: 'private',
                                operations: ['read'],
                            },
                        ],
                    },
                },
            ],
        },
        UserProductInterest: {
            name: 'UserProductInterest',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                userProfile: {
                    name: 'userProfile',
                    isArray: false,
                    type: {
                        model: 'UserProfile',
                    },
                    isRequired: false,
                    attributes: [],
                    association: {
                        connectionType: 'BELONGS_TO',
                        targetName: 'userProfileId',
                    },
                },
                productInterest: {
                    name: 'productInterest',
                    isArray: false,
                    type: {
                        model: 'ProductInterest',
                    },
                    isRequired: false,
                    attributes: [],
                    association: {
                        connectionType: 'BELONGS_TO',
                        targetName: 'productInterestId',
                    },
                },
            },
            syncable: true,
            pluralName: 'UserProductInterests',
            attributes: [
                {
                    type: 'model',
                    properties: {
                        queries: null,
                        timestamps: {
                            createdAt: 'createdOn',
                            updatedAt: 'updatedOn',
                        },
                    },
                },
                {
                    type: 'key',
                    properties: {
                        name: 'byUserProfile',
                        fields: ['userProfileId', 'productInterestId'],
                    },
                },
                {
                    type: 'key',
                    properties: {
                        name: 'byInterest',
                        fields: ['productInterestId', 'userProfileId'],
                    },
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                provider: 'userPools',
                                ownerField: 'owner',
                                allow: 'owner',
                                identityClaim: 'cognito:username',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                        ],
                    },
                },
            ],
        },
        ProductInterest: {
            name: 'ProductInterest',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                text: {
                    name: 'text',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                users: {
                    name: 'users',
                    isArray: true,
                    type: {
                        model: 'UserProductInterest',
                    },
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                    association: {
                        connectionType: 'HAS_MANY',
                        associatedWith: 'productInterest',
                    },
                },
            },
            syncable: true,
            pluralName: 'ProductInterests',
            attributes: [
                {
                    type: 'model',
                    properties: {
                        timestamps: {
                            createdAt: 'createdOn',
                            updatedAt: 'updatedOn',
                        },
                    },
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                provider: 'userPools',
                                ownerField: 'owner',
                                allow: 'owner',
                                operations: ['create', 'delete', 'update'],
                                identityClaim: 'cognito:username',
                            },
                        ],
                    },
                },
            ],
        },
        FeatureFlag: {
            name: 'FeatureFlag',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                name: {
                    name: 'name',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                code: {
                    name: 'code',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                enabled: {
                    name: 'enabled',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: true,
                    attributes: [],
                },
            },
            syncable: true,
            pluralName: 'FeatureFlags',
            attributes: [
                {
                    type: 'model',
                    properties: {
                        timestamps: {
                            createdAt: 'createdOn',
                            updatedAt: 'updatedOn',
                        },
                    },
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                allow: 'private',
                                operations: ['read'],
                            },
                        ],
                    },
                },
            ],
        },
        CreditScoreProvider: {
            name: 'CreditScoreProvider',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                name: {
                    name: 'name',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                region: {
                    name: 'region',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
            },
            syncable: true,
            pluralName: 'CreditScoreProviders',
            attributes: [
                {
                    type: 'model',
                    properties: {
                        timestamps: {
                            createdAt: 'createdOn',
                            updatedAt: 'updatedOn',
                        },
                        mutations: null,
                        subscriptions: null,
                    },
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                allow: 'private',
                                operations: ['read'],
                            },
                        ],
                    },
                },
            ],
        },
        UserCreditScore: {
            name: 'UserCreditScore',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                representativeId: {
                    name: 'representativeId',
                    isArray: false,
                    type: 'ID',
                    isRequired: false,
                    attributes: [],
                },
            },
            syncable: true,
            pluralName: 'UserCreditScores',
            attributes: [
                {
                    type: 'model',
                    properties: {
                        queries: null,
                        mutations: null,
                        subscriptions: null,
                        timestamps: {
                            createdAt: 'createdOn',
                            updatedAt: 'updatedOn',
                        },
                    },
                },
            ],
        },
        SystemCredentials: {
            name: 'SystemCredentials',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                token: {
                    name: 'token',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                expiresIn: {
                    name: 'expiresIn',
                    isArray: false,
                    type: 'Int',
                    isRequired: false,
                    attributes: [],
                },
            },
            syncable: true,
            pluralName: 'SystemCredentials',
            attributes: [
                {
                    type: 'model',
                    properties: {
                        queries: null,
                        mutations: null,
                        subscriptions: null,
                        timestamps: {
                            createdAt: 'createdOn',
                            updatedAt: 'updatedOn',
                        },
                    },
                },
            ],
        },
        PlaidUserInfo: {
            name: 'PlaidUserInfo',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                itemId: {
                    name: 'itemId',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                userProfileId: {
                    name: 'userProfileId',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                token: {
                    name: 'token',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                institutionName: {
                    name: 'institutionName',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                institutionId: {
                    name: 'institutionId',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
            },
            syncable: true,
            pluralName: 'PlaidUserInfos',
            attributes: [
                {
                    type: 'model',
                    properties: {
                        queries: null,
                        mutations: null,
                        subscriptions: null,
                        timestamps: {
                            createdAt: 'createdOn',
                            updatedAt: 'updatedOn',
                        },
                    },
                },
                {
                    type: 'key',
                    properties: {
                        name: 'byUserProfile',
                        fields: ['userProfileId'],
                    },
                },
                {
                    type: 'key',
                    properties: {
                        name: 'byItemId',
                        fields: ['itemId'],
                    },
                },
            ],
        },
        PlaidReportToken: {
            name: 'PlaidReportToken',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                token: {
                    name: 'token',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                itemId: {
                    name: 'itemId',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                userProfileId: {
                    name: 'userProfileId',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                from: {
                    name: 'from',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: true,
                    attributes: [],
                },
                to: {
                    name: 'to',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: true,
                    attributes: [],
                },
                generatedOn: {
                    name: 'generatedOn',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: true,
                    attributes: [],
                },
                dataPulled: {
                    name: 'dataPulled',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                dataPulledOn: {
                    name: 'dataPulledOn',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                },
            },
            syncable: true,
            pluralName: 'PlaidReportTokens',
            attributes: [
                {
                    type: 'model',
                    properties: {
                        queries: null,
                        mutations: null,
                        subscriptions: null,
                        timestamps: {
                            createdAt: 'createdOn',
                            updatedAt: 'updatedOn',
                        },
                    },
                },
                {
                    type: 'key',
                    properties: {
                        name: 'byMostRecentPending',
                        fields: ['dataPulled', 'generatedOn'],
                    },
                },
            ],
        },
        PlaidHistoricalBalance: {
            name: 'PlaidHistoricalBalance',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                amount: {
                    name: 'amount',
                    isArray: false,
                    type: 'Float',
                    isRequired: true,
                    attributes: [],
                },
                date: {
                    name: 'date',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                accountId: {
                    name: 'accountId',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                itemId: {
                    name: 'itemId',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                userProfileId: {
                    name: 'userProfileId',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
            },
            syncable: true,
            pluralName: 'PlaidHistoricalBalances',
            attributes: [
                {
                    type: 'model',
                    properties: {
                        mutations: null,
                        subscriptions: null,
                        timestamps: {
                            createdAt: 'createdOn',
                            updatedAt: 'updatedOn',
                        },
                    },
                },
                {
                    type: 'key',
                    properties: {
                        name: 'byUserProfile',
                        fields: ['userProfileId', 'itemId'],
                        queryField: 'userHistoricalBalances',
                    },
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                provider: 'userPools',
                                ownerField: 'owner',
                                allow: 'owner',
                                identityClaim: 'cognito:username',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                        ],
                    },
                },
            ],
        },
        PlaidAccountIdentity: {
            name: 'PlaidAccountIdentity',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                userProfileId: {
                    name: 'userProfileId',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                emails: {
                    name: 'emails',
                    isArray: true,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
                names: {
                    name: 'names',
                    isArray: true,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
                phones: {
                    name: 'phones',
                    isArray: true,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
                addresses: {
                    name: 'addresses',
                    isArray: true,
                    type: {
                        nonModel: 'PlaidIdentityAddress',
                    },
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
            },
            syncable: true,
            pluralName: 'PlaidAccountIdentities',
            attributes: [
                {
                    type: 'model',
                    properties: {
                        queries: null,
                        mutations: null,
                        subscriptions: null,
                        timestamps: {
                            createdAt: 'createdOn',
                            updatedAt: 'updatedOn',
                        },
                    },
                },
                {
                    type: 'key',
                    properties: {
                        name: 'byUserProfile',
                        fields: ['userProfileId'],
                    },
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                provider: 'userPools',
                                ownerField: 'owner',
                                allow: 'owner',
                                identityClaim: 'cognito:username',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                        ],
                    },
                },
            ],
        },
        PlaidAccountTransaction: {
            name: 'PlaidAccountTransaction',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                userProfileId: {
                    name: 'userProfileId',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                accountId: {
                    name: 'accountId',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                itemId: {
                    name: 'itemId',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                amount: {
                    name: 'amount',
                    isArray: false,
                    type: 'Float',
                    isRequired: true,
                    attributes: [],
                },
                transactionType: {
                    name: 'transactionType',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                date: {
                    name: 'date',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                name: {
                    name: 'name',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                category: {
                    name: 'category',
                    isArray: true,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
            },
            syncable: true,
            pluralName: 'PlaidAccountTransactions',
            attributes: [
                {
                    type: 'model',
                    properties: {
                        mutations: null,
                        timestamps: {
                            createdAt: 'createdOn',
                            updatedAt: 'updatedOn',
                        },
                    },
                },
                {
                    type: 'key',
                    properties: {
                        name: 'byUserProfile',
                        fields: ['userProfileId', 'date'],
                    },
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                provider: 'userPools',
                                ownerField: 'owner',
                                allow: 'owner',
                                identityClaim: 'cognito:username',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                        ],
                    },
                },
            ],
        },
        ZaboUserInfo: {
            name: 'ZaboUserInfo',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                userId: {
                    name: 'userId',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                accountId: {
                    name: 'accountId',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                userProfileId: {
                    name: 'userProfileId',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                token: {
                    name: 'token',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
            },
            syncable: true,
            pluralName: 'ZaboUserInfos',
            attributes: [
                {
                    type: 'model',
                    properties: {
                        mutations: null,
                        queries: null,
                        subscriptions: null,
                        timestamps: {
                            createdAt: 'createdOn',
                            updatedAt: 'updatedOn',
                        },
                    },
                },
                {
                    type: 'key',
                    properties: {
                        name: 'byUserProfile',
                        fields: ['userProfileId'],
                    },
                },
                {
                    type: 'key',
                    properties: {
                        name: 'byAccount',
                        fields: ['accountId'],
                    },
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                provider: 'userPools',
                                ownerField: 'owner',
                                allow: 'owner',
                                identityClaim: 'cognito:username',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                        ],
                    },
                },
            ],
        },
        CryptoUserConnection: {
            name: 'CryptoUserConnection',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                userProfileId: {
                    name: 'userProfileId',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                credential: {
                    name: 'credential',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                complementaryCredential: {
                    name: 'complementaryCredential',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                provider: {
                    name: 'provider',
                    isArray: false,
                    type: {
                        enum: 'CryptoAccountProvider',
                    },
                    isRequired: true,
                    attributes: [],
                },
                institution: {
                    name: 'institution',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
            },
            syncable: true,
            pluralName: 'CryptoUserConnections',
            attributes: [
                {
                    type: 'model',
                    properties: {
                        mutations: null,
                        queries: null,
                        subscriptions: null,
                        timestamps: {
                            createdAt: 'createdOn',
                            updatedAt: 'updatedOn',
                        },
                    },
                },
                {
                    type: 'key',
                    properties: {
                        name: 'byUserProfile',
                        fields: ['userProfileId'],
                    },
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                provider: 'userPools',
                                ownerField: 'owner',
                                allow: 'owner',
                                identityClaim: 'cognito:username',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                        ],
                    },
                },
            ],
        },
        ZaboAccountBalance: {
            name: 'ZaboAccountBalance',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                userId: {
                    name: 'userId',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                accountId: {
                    name: 'accountId',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                userProfileId: {
                    name: 'userProfileId',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                ticker: {
                    name: 'ticker',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                provivderName: {
                    name: 'provivderName',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                name: {
                    name: 'name',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                assetVerified: {
                    name: 'assetVerified',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: false,
                    attributes: [],
                },
                amount: {
                    name: 'amount',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                fiatCurrency: {
                    name: 'fiatCurrency',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                fiatValue: {
                    name: 'fiatValue',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                logo: {
                    name: 'logo',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                provider: {
                    name: 'provider',
                    isArray: false,
                    type: {
                        nonModel: 'ZaboProvider',
                    },
                    isRequired: true,
                    attributes: [],
                },
            },
            syncable: true,
            pluralName: 'ZaboAccountBalances',
            attributes: [
                {
                    type: 'model',
                    properties: {
                        mutations: null,
                        timestamps: {
                            createdAt: 'createdOn',
                            updatedAt: 'updatedOn',
                        },
                    },
                },
                {
                    type: 'key',
                    properties: {
                        name: 'byUserProfile',
                        fields: ['userProfileId', 'amount'],
                    },
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                provider: 'userPools',
                                ownerField: 'owner',
                                allow: 'owner',
                                identityClaim: 'cognito:username',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                        ],
                    },
                },
            ],
        },
        ZaboHistoricalBalance: {
            name: 'ZaboHistoricalBalance',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                userId: {
                    name: 'userId',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                accountId: {
                    name: 'accountId',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                userProfileId: {
                    name: 'userProfileId',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                date: {
                    name: 'date',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: true,
                    attributes: [],
                },
                ticker: {
                    name: 'ticker',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                provivderName: {
                    name: 'provivderName',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                name: {
                    name: 'name',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                assetVerified: {
                    name: 'assetVerified',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: false,
                    attributes: [],
                },
                amount: {
                    name: 'amount',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                fiatCurrency: {
                    name: 'fiatCurrency',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                fiatValue: {
                    name: 'fiatValue',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                logo: {
                    name: 'logo',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
            },
            syncable: true,
            pluralName: 'ZaboHistoricalBalances',
            attributes: [
                {
                    type: 'model',
                    properties: {
                        mutations: null,
                        timestamps: {
                            createdAt: 'createdOn',
                            updatedAt: 'updatedOn',
                        },
                    },
                },
                {
                    type: 'key',
                    properties: {
                        name: 'byUserProfile',
                        fields: ['userProfileId', 'accountId'],
                    },
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                provider: 'userPools',
                                ownerField: 'owner',
                                allow: 'owner',
                                identityClaim: 'cognito:username',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                        ],
                    },
                },
            ],
        },
        ZaboAccountTransaction: {
            name: 'ZaboAccountTransaction',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                userId: {
                    name: 'userId',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                accountId: {
                    name: 'accountId',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                userProfileId: {
                    name: 'userProfileId',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                status: {
                    name: 'status',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                transactionType: {
                    name: 'transactionType',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                parts: {
                    name: 'parts',
                    isArray: true,
                    type: {
                        nonModel: 'ZaboTransactionPart',
                    },
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
                fees: {
                    name: 'fees',
                    isArray: true,
                    type: {
                        nonModel: 'ZaboTransactionFee',
                    },
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
                misc: {
                    name: 'misc',
                    isArray: true,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
                fiatCalculatedAt: {
                    name: 'fiatCalculatedAt',
                    isArray: false,
                    type: 'Float',
                    isRequired: false,
                    attributes: [],
                },
                initiatedAt: {
                    name: 'initiatedAt',
                    isArray: false,
                    type: 'Float',
                    isRequired: false,
                    attributes: [],
                },
                confirmedAt: {
                    name: 'confirmedAt',
                    isArray: false,
                    type: 'Float',
                    isRequired: false,
                    attributes: [],
                },
            },
            syncable: true,
            pluralName: 'ZaboAccountTransactions',
            attributes: [
                {
                    type: 'model',
                    properties: {
                        mutations: null,
                        timestamps: {
                            createdAt: 'createdOn',
                            updatedAt: 'updatedOn',
                        },
                    },
                },
                {
                    type: 'key',
                    properties: {
                        name: 'byUserProfile',
                        fields: ['userProfileId', 'confirmedAt'],
                    },
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                provider: 'userPools',
                                ownerField: 'owner',
                                allow: 'owner',
                                identityClaim: 'cognito:username',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                        ],
                    },
                },
            ],
        },
    },
    enums: {
        AccountProvider: {
            name: 'AccountProvider',
            values: ['COINBASE', 'VEZGO', 'PLAID'],
        },
        ClientPlatform: {
            name: 'ClientPlatform',
            values: ['WEB', 'ANDROID', 'IOS'],
        },
        MasaConnectionProvider: {
            name: 'MasaConnectionProvider',
            values: ['PLAID', 'CRYPTO', 'VEZGO', 'MASA'],
        },
        MasaAccountType: {
            name: 'MasaAccountType',
            values: ['BANK', 'CRYPTO'],
        },
        CryptoDataProviders: {
            name: 'CryptoDataProviders',
            values: ['MASA', 'VEZGO'],
        },
        DeleteType: {
            name: 'DeleteType',
            values: ['TOTAL', 'HARD', 'SOFT'],
        },
        UserRole: {
            name: 'UserRole',
            values: [
                'INDIVIDUAL',
                'BUSINESS',
                'LIQUIDITY_PROVIDER',
                'VALIDATOR',
                'ADMIN',
            ],
        },
        CryptoAccountProvider: {
            name: 'CryptoAccountProvider',
            values: ['VEZGO', 'MASA'],
        },
    },
    nonModels: {
        listLoanApplicationsFromNodeResponse: {
            name: 'listLoanApplicationsFromNodeResponse',
            fields: {
                data: {
                    name: 'data',
                    isArray: true,
                    type: {
                        nonModel: 'LoanApplicationFromNode',
                    },
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
            },
        },
        LoanApplicationFromNode: {
            name: 'LoanApplicationFromNode',
            fields: {
                loan_application_id: {
                    name: 'loan_application_id',
                    isArray: false,
                    type: 'ID',
                    isRequired: false,
                    attributes: [],
                },
                institution_id: {
                    name: 'institution_id',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                name: {
                    name: 'name',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                loan_product: {
                    name: 'loan_product',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                status: {
                    name: 'status',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                loan_purpose: {
                    name: 'loan_purpose',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                data: {
                    name: 'data',
                    isArray: false,
                    type: {
                        nonModel: 'LoanApplicationFromNodeData',
                    },
                    isRequired: false,
                    attributes: [],
                },
                repayment_history: {
                    name: 'repayment_history',
                    isArray: true,
                    type: {
                        nonModel: 'LoanApplicationFromNodeRepayment',
                    },
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
            },
        },
        LoanApplicationFromNodeData: {
            name: 'LoanApplicationFromNodeData',
            fields: {
                prequalification_amount: {
                    name: 'prequalification_amount',
                    isArray: false,
                    type: 'Int',
                    isRequired: false,
                    attributes: [],
                },
                date: {
                    name: 'date',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                amount: {
                    name: 'amount',
                    isArray: false,
                    type: 'Int',
                    isRequired: false,
                    attributes: [],
                },
                principal: {
                    name: 'principal',
                    isArray: false,
                    type: 'Int',
                    isRequired: false,
                    attributes: [],
                },
                interest: {
                    name: 'interest',
                    isArray: false,
                    type: 'Int',
                    isRequired: false,
                    attributes: [],
                },
                interest_rate: {
                    name: 'interest_rate',
                    isArray: false,
                    type: 'Float',
                    isRequired: false,
                    attributes: [],
                },
                fees: {
                    name: 'fees',
                    isArray: false,
                    type: 'Float',
                    isRequired: false,
                    attributes: [],
                },
                ltv_ratio: {
                    name: 'ltv_ratio',
                    isArray: false,
                    type: 'Float',
                    isRequired: false,
                    attributes: [],
                },
                iso_currency_code: {
                    name: 'iso_currency_code',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                term: {
                    name: 'term',
                    isArray: false,
                    type: 'Int',
                    isRequired: false,
                    attributes: [],
                },
                last_updated: {
                    name: 'last_updated',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                collateral: {
                    name: 'collateral',
                    isArray: false,
                    type: {
                        nonModel: 'LoanApplicationFromNodeCollateralData',
                    },
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        LoanApplicationFromNodeCollateralData: {
            name: 'LoanApplicationFromNodeCollateralData',
            fields: {
                asset: {
                    name: 'asset',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                asset_type: {
                    name: 'asset_type',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                owner_account: {
                    name: 'owner_account',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                floor_value: {
                    name: 'floor_value',
                    isArray: false,
                    type: 'Int',
                    isRequired: false,
                    attributes: [],
                },
                value: {
                    name: 'value',
                    isArray: false,
                    type: 'Int',
                    isRequired: false,
                    attributes: [],
                },
                iso_currency_code: {
                    name: 'iso_currency_code',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                metadata: {
                    name: 'metadata',
                    isArray: false,
                    type: {
                        nonModel: 'LoanApplicationFromNodeCollateralMetadata',
                    },
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        LoanApplicationFromNodeCollateralMetadata: {
            name: 'LoanApplicationFromNodeCollateralMetadata',
            fields: {
                contract_address: {
                    name: 'contract_address',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                metadata_url: {
                    name: 'metadata_url',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                token_id: {
                    name: 'token_id',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                token_standard: {
                    name: 'token_standard',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                chain: {
                    name: 'chain',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        LoanApplicationFromNodeRepayment: {
            name: 'LoanApplicationFromNodeRepayment',
            fields: {
                repayment_id: {
                    name: 'repayment_id',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                amount: {
                    name: 'amount',
                    isArray: false,
                    type: 'Int',
                    isRequired: false,
                    attributes: [],
                },
                principal: {
                    name: 'principal',
                    isArray: false,
                    type: 'Int',
                    isRequired: false,
                    attributes: [],
                },
                interest: {
                    name: 'interest',
                    isArray: false,
                    type: 'Int',
                    isRequired: false,
                    attributes: [],
                },
                fees: {
                    name: 'fees',
                    isArray: false,
                    type: 'Int',
                    isRequired: false,
                    attributes: [],
                },
                iso_currency_code: {
                    name: 'iso_currency_code',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                date_due: {
                    name: 'date_due',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                date_received: {
                    name: 'date_received',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                status: {
                    name: 'status',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        getLoanApplicationsFromNodeResponse: {
            name: 'getLoanApplicationsFromNodeResponse',
            fields: {
                data: {
                    name: 'data',
                    isArray: false,
                    type: {
                        nonModel: 'LoanApplicationFromNode',
                    },
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        GetPreQualificationDataResponseType: {
            name: 'GetPreQualificationDataResponseType',
            fields: {
                totalNetWorth: {
                    name: 'totalNetWorth',
                    isArray: false,
                    type: 'Float',
                    isRequired: false,
                    attributes: [],
                },
                totalCryptoWorth: {
                    name: 'totalCryptoWorth',
                    isArray: false,
                    type: 'Float',
                    isRequired: false,
                    attributes: [],
                },
                totalAssets: {
                    name: 'totalAssets',
                    isArray: false,
                    type: 'Float',
                    isRequired: false,
                    attributes: [],
                },
                totalDebt: {
                    name: 'totalDebt',
                    isArray: false,
                    type: 'Float',
                    isRequired: false,
                    attributes: [],
                },
                monthlyIncome: {
                    name: 'monthlyIncome',
                    isArray: false,
                    type: 'Float',
                    isRequired: false,
                    attributes: [],
                },
                debtToIncomeRatio: {
                    name: 'debtToIncomeRatio',
                    isArray: false,
                    type: 'Float',
                    isRequired: false,
                    attributes: [],
                },
                freeCashFlow: {
                    name: 'freeCashFlow',
                    isArray: false,
                    type: 'Float',
                    isRequired: false,
                    attributes: [],
                },
                preQualified: {
                    name: 'preQualified',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        GetLinkResponseType: {
            name: 'GetLinkResponseType',
            fields: {
                link: {
                    name: 'link',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                expiration: {
                    name: 'expiration',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                },
                link_token: {
                    name: 'link_token',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                request_id: {
                    name: 'request_id',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                status_code: {
                    name: 'status_code',
                    isArray: false,
                    type: 'Int',
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        VezgoProvider: {
            name: 'VezgoProvider',
            fields: {
                name: {
                    name: 'name',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                displayName: {
                    name: 'displayName',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                logo: {
                    name: 'logo',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                authType: {
                    name: 'authType',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                status: {
                    name: 'status',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                isBeta: {
                    name: 'isBeta',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: false,
                    attributes: [],
                },
                credentials: {
                    name: 'credentials',
                    isArray: true,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
            },
        },
        GetApprovedCountriesResponseType: {
            name: 'GetApprovedCountriesResponseType',
            fields: {
                banking: {
                    name: 'banking',
                    isArray: true,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
                credit: {
                    name: 'credit',
                    isArray: true,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
                pngme: {
                    name: 'pngme',
                    isArray: true,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
            },
        },
        ListMasaAccountsResponse: {
            name: 'ListMasaAccountsResponse',
            fields: {
                items: {
                    name: 'items',
                    isArray: true,
                    type: {
                        nonModel: 'MasaAccount',
                    },
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
                nextToken: {
                    name: 'nextToken',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        MasaAccount: {
            name: 'MasaAccount',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: false,
                    attributes: [],
                },
                accountId: {
                    name: 'accountId',
                    isArray: false,
                    type: 'ID',
                    isRequired: false,
                    attributes: [],
                },
                name: {
                    name: 'name',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                type: {
                    name: 'type',
                    isArray: false,
                    type: {
                        enum: 'MasaAccountType',
                    },
                    isRequired: false,
                    attributes: [],
                },
                subtype: {
                    name: 'subtype',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                amount: {
                    name: 'amount',
                    isArray: false,
                    type: {
                        nonModel: 'MasaAmount',
                    },
                    isRequired: false,
                    attributes: [],
                },
                lastUpdated: {
                    name: 'lastUpdated',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                },
                provider: {
                    name: 'provider',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        MasaAmount: {
            name: 'MasaAmount',
            fields: {
                value: {
                    name: 'value',
                    isArray: false,
                    type: 'Float',
                    isRequired: false,
                    attributes: [],
                },
                currency: {
                    name: 'currency',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                fiatValue: {
                    name: 'fiatValue',
                    isArray: false,
                    type: 'Float',
                    isRequired: false,
                    attributes: [],
                },
                fiatCurrency: {
                    name: 'fiatCurrency',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        ListBankTransactionsResponse: {
            name: 'ListBankTransactionsResponse',
            fields: {
                items: {
                    name: 'items',
                    isArray: true,
                    type: {
                        nonModel: 'BankTransaction',
                    },
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
                nextToken: {
                    name: 'nextToken',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        BankTransaction: {
            name: 'BankTransaction',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                accountId: {
                    name: 'accountId',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                itemId: {
                    name: 'itemId',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                amount: {
                    name: 'amount',
                    isArray: false,
                    type: {
                        nonModel: 'TransactionComplexField',
                    },
                    isRequired: false,
                    attributes: [],
                },
                impact: {
                    name: 'impact',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                date: {
                    name: 'date',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                description: {
                    name: 'description',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                type: {
                    name: 'type',
                    isArray: true,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
            },
        },
        TransactionComplexField: {
            name: 'TransactionComplexField',
            fields: {
                value: {
                    name: 'value',
                    isArray: false,
                    type: 'Float',
                    isRequired: false,
                    attributes: [],
                },
                currency: {
                    name: 'currency',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        ListCryptoTransactionsResponse: {
            name: 'ListCryptoTransactionsResponse',
            fields: {
                items: {
                    name: 'items',
                    isArray: true,
                    type: {
                        nonModel: 'CryptoTransaction',
                    },
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
                nextToken: {
                    name: 'nextToken',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        CryptoTransaction: {
            name: 'CryptoTransaction',
            fields: {
                name: {
                    name: 'name',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                impact: {
                    name: 'impact',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                fiat: {
                    name: 'fiat',
                    isArray: false,
                    type: {
                        nonModel: 'TransactionComplexField',
                    },
                    isRequired: false,
                    attributes: [],
                },
                date: {
                    name: 'date',
                    isArray: false,
                    type: 'Float',
                    isRequired: false,
                    attributes: [],
                },
                transactionType: {
                    name: 'transactionType',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                category: {
                    name: 'category',
                    isArray: true,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
                amount: {
                    name: 'amount',
                    isArray: false,
                    type: {
                        nonModel: 'TransactionComplexField',
                    },
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        GetGraphDataResponse: {
            name: 'GetGraphDataResponse',
            fields: {
                crypto: {
                    name: 'crypto',
                    isArray: true,
                    type: {
                        nonModel: 'GraphDataPoint',
                    },
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
                bank: {
                    name: 'bank',
                    isArray: true,
                    type: {
                        nonModel: 'GraphDataPoint',
                    },
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
                balance: {
                    name: 'balance',
                    isArray: false,
                    type: 'Float',
                    isRequired: false,
                    attributes: [],
                },
                balanceDate: {
                    name: 'balanceDate',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        GraphDataPoint: {
            name: 'GraphDataPoint',
            fields: {
                value: {
                    name: 'value',
                    isArray: false,
                    type: 'Float',
                    isRequired: false,
                    attributes: [],
                },
                date: {
                    name: 'date',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        RegisterCreditScoreRepresentativeResponse: {
            name: 'RegisterCreditScoreRepresentativeResponse',
            fields: {
                authenticationCompleted: {
                    name: 'authenticationCompleted',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: false,
                    attributes: [],
                },
                questionaryId: {
                    name: 'questionaryId',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                questions: {
                    name: 'questions',
                    isArray: true,
                    type: {
                        nonModel: 'ProcessedBloomCreditQuestions',
                    },
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
            },
        },
        ProcessedBloomCreditQuestions: {
            name: 'ProcessedBloomCreditQuestions',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                text: {
                    name: 'text',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                options: {
                    name: 'options',
                    isArray: true,
                    type: {
                        nonModel: 'ProcessedBloomCreditQuestionsOption',
                    },
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
            },
        },
        ProcessedBloomCreditQuestionsOption: {
            name: 'ProcessedBloomCreditQuestionsOption',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                text: {
                    name: 'text',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        AuthenticateCreditScoreRepresentativeResponse: {
            name: 'AuthenticateCreditScoreRepresentativeResponse',
            fields: {
                questionaryStatus: {
                    name: 'questionaryStatus',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                additionalQuestionsNeeded: {
                    name: 'additionalQuestionsNeeded',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        FetchCreditScoreResponse: {
            name: 'FetchCreditScoreResponse',
            fields: {
                score: {
                    name: 'score',
                    isArray: false,
                    type: 'Int',
                    isRequired: false,
                    attributes: [],
                },
                scoreReady: {
                    name: 'scoreReady',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        ExchangePublicTokenResponseType: {
            name: 'ExchangePublicTokenResponseType',
            fields: {
                balances: {
                    name: 'balances',
                    isArray: true,
                    type: {
                        model: 'PlaidAccount',
                    },
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
            },
        },
        UpdateUserInterestsResponseType: {
            name: 'UpdateUserInterestsResponseType',
            fields: {
                deleted: {
                    name: 'deleted',
                    isArray: true,
                    type: 'ID',
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
                created: {
                    name: 'created',
                    isArray: true,
                    type: 'ID',
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
            },
        },
        RegenerateUserDataOutput: {
            name: 'RegenerateUserDataOutput',
            fields: {
                from: {
                    name: 'from',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                },
                to: {
                    name: 'to',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                },
                fiatConnectionsCount: {
                    name: 'fiatConnectionsCount',
                    isArray: false,
                    type: 'Int',
                    isRequired: false,
                    attributes: [],
                },
                cryptoCredentialsCount: {
                    name: 'cryptoCredentialsCount',
                    isArray: false,
                    type: 'Int',
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        PlaidIdentityAddress: {
            name: 'PlaidIdentityAddress',
            fields: {
                city: {
                    name: 'city',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                country: {
                    name: 'country',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                postalCode: {
                    name: 'postalCode',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                region: {
                    name: 'region',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                street: {
                    name: 'street',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                primary: {
                    name: 'primary',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: true,
                    attributes: [],
                },
            },
        },
        ZaboProvider: {
            name: 'ZaboProvider',
            fields: {
                displayName: {
                    name: 'displayName',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                logo: {
                    name: 'logo',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                authType: {
                    name: 'authType',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                scopes: {
                    name: 'scopes',
                    isArray: true,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
            },
        },
        ZaboTransactionPart: {
            name: 'ZaboTransactionPart',
            fields: {
                direction: {
                    name: 'direction',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                ticker: {
                    name: 'ticker',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                providerTicker: {
                    name: 'providerTicker',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                amount: {
                    name: 'amount',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                assetVerified: {
                    name: 'assetVerified',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: false,
                    attributes: [],
                },
                fiatCurrency: {
                    name: 'fiatCurrency',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                fiatValue: {
                    name: 'fiatValue',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                otherParties: {
                    name: 'otherParties',
                    isArray: true,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
            },
        },
        ZaboTransactionFee: {
            name: 'ZaboTransactionFee',
            fields: {
                type: {
                    name: 'type',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                ticker: {
                    name: 'ticker',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                providerTicker: {
                    name: 'providerTicker',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                amount: {
                    name: 'amount',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                assetVerified: {
                    name: 'assetVerified',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: false,
                    attributes: [],
                },
                fiatCurrency: {
                    name: 'fiatCurrency',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                fiatValue: {
                    name: 'fiatValue',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        listLoansFromNodeResponse: {
            name: 'listLoansFromNodeResponse',
            fields: {
                data: {
                    name: 'data',
                    isArray: true,
                    type: {
                        nonModel: 'LoanApplicationFromNode',
                    },
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
            },
        },
        ClientMetadata: {
            name: 'ClientMetadata',
            fields: {
                client_id: {
                    name: 'client_id',
                    isArray: false,
                    type: 'ID',
                    isRequired: false,
                    attributes: [],
                },
                user_id: {
                    name: 'user_id',
                    isArray: false,
                    type: 'ID',
                    isRequired: false,
                    attributes: [],
                },
            },
        },
    },
    version: '8ca5da6a81440e27df99ac6bf859932a',
}
